import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
//import * as moment from 'moment';

@Component({
  selector: 'app-whatsapp-solicitacao-cadastro',
  templateUrl: './whatsapp-solicitacao-cadastro.component.html',
  styleUrls: ['./whatsapp-solicitacao-cadastro.component.scss'],
})
export class WhatsappSolicitacaoCadastroComponent implements OnInit {
  form: UntypedFormGroup;
  description: string;

  constructor(
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<WhatsappSolicitacaoCadastroComponent>,
    @Inject(MAT_DIALOG_DATA) { description, longDescription, category }
  ) {
    this.description = description;

    this.form = fb.group({
      description: [description, Validators.required],
      category: [category, Validators.required],
      releasedAt: null, //[moment(), Validators.required],
      longDescription: [longDescription, Validators.required],
    });
  }

  ngOnInit() {}

  save() {
    this.dialogRef.close(this.form.value);
  }

  close() {
    this.dialogRef.close();
  }
}
